import React, { useContext, useEffect } from 'react'
import './index.scss'
import { USER_PROFILE_TABS } from '@Const/tabs-constants'
import ProfileSceneUserTab from '@Scenes/ProfileScene/ProfileSceneUserTab'
import ProfileSceneRightsholderTab from '@Scenes/ProfileScene/ProfileSceneRightsholderTab'
import { StoresContext } from '@App/contexts'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import ProfileSceneSongwriterTab from '@Scenes/ProfileScene/ProfileSceneSongwriterTab'
import { useFlag } from '@openfeature/react-sdk'

const ProfileScene = () => {
    const { value: showSongwriterTab } = useFlag('member-songwriter-signup-rework', false)

    const { userStore } = useContext(StoresContext)
    const tabs: Tab[] = [
        {
            tabName: USER_PROFILE_TABS.user,
            tabDisplayName: USER_PROFILE_TABS.user,
            tabComponent: <ProfileSceneUserTab key={USER_PROFILE_TABS.user} />,
        },
        {
            tabName: USER_PROFILE_TABS.rightsholders,
            tabDisplayName: USER_PROFILE_TABS.rightsholders,
            tabComponent: <ProfileSceneRightsholderTab key={USER_PROFILE_TABS.rightsholders} />,
        },
        ...(showSongwriterTab
            ? [
                  {
                      tabName: USER_PROFILE_TABS.songwriters,
                      tabDisplayName: USER_PROFILE_TABS.songwriters,
                      tabComponent: <ProfileSceneSongwriterTab key={USER_PROFILE_TABS.songwriters} />,
                  },
              ]
            : []),
    ]
    useEffect(() => {
        analyticsSendPage('profile')
    }, [])
    return userStore.userInfo ? (
        <>
            <title>Profile</title>
            <main className="profile-scene">
                <div className="global-container">
                    <div className="head">
                        <h2>Profile</h2>
                    </div>
                    <TabsWrapperComponent tabs={tabs} defaultTab={tabs[0]} />
                </div>
            </main>
        </>
    ) : null
}

export default ProfileScene
